<ng-container *transloco="let t">
  <!--Closed Profile Dropdown-->
  <div [appDropdownTriggerFor]="dropdown" (overlayClosed)="onToggleDropdown($event)">
    <div class="account-picker">
      <div class="flex flex-space-between flex-align-center">
        <div class="account-picker__avatar">
          <p class="kxi-text-medium">
            {{ userInitials() }}
          </p>
        </div>

        <div class="acount-picker__account-info">
          <p class="kxi-text-normal kxi-text-600 orca-primary account-picker__username">
            {{ userName() | truncate }}
          </p>
          <p class="kxi-text-xsmall orca-primary">{{ userTimezone() }}</p>
        </div>
      </div>

      <div
        [ngClass]="dropdownOpen ? 'account-picker__arrow--open' : 'account-picker__arrow--closed'"
      >
        <xi-icon icon="single_arrow_down"></xi-icon>
      </div>
    </div>
  </div>

  <!--Open Profile Dropdown-->
  <app-account-dropdown #dropdown>
    <div [class.dropdown]="!authService.isSharedSession">
      <div class="menu-container">
        <div class="account-picker">
          <div class="flex flex-space-between flex-align-center">
            <div class="account-picker__avatar">
              <p class="kxi-text-medium">
                {{ userInitials() }}
              </p>
            </div>

            <div class="acount-picker__account-info">
              <p class="kxi-text-normal kxi-text-600 orca-primary account-picker__username">
                {{ userName() | truncate }}
              </p>
              <p class="kxi-text-xsmall orca-primary">{{ userTimezone() }}</p>
            </div>
          </div>

          <div [@arrowState]="state">
            <xi-icon icon="single_arrow_down"></xi-icon>
          </div>
        </div>

        <div class="border-divider"></div>
        <div class="dropdown-open">
          @if (!isSSOUser && !this.authService.isSharedSession) {
            <div class="dropdown-open__account-button">
              <xi-default-button
                [stretch]="true"
                buttonSize="small"
                text="{{ t('account-dropdown-wrapper.change-password') }}"
                color="orca"
                (onClick)="onOpenChangePassword()"
              ></xi-default-button>
            </div>
          }
          @if (!this.authService.isSharedSession) {
            <div class="dropdown-open__homepage-button">
              <xi-default-button
                [stretch]="true"
                buttonSize="small"
                iconLeft="app_home"
                text="{{ t('account-dropdown-wrapper.make-this-my-homepage') }}"
                fill="text"
                (onClick)="setHome()"
              >
              </xi-default-button>
            </div>
          }
          <div class="dropdown-open__homepage-button">
            <xi-default-button
              [stretch]="true"
              buttonSize="small"
              iconLeft="clock_2"
              text="{{ t('account-dropdown-wrapper.set-default-timezone') }}"
              fill="text"
              (onClick)="changeTimezone()"
            >
            </xi-default-button>
          </div>
          <div class="dropdown-open__homepage-button">
            <xi-default-button
              [stretch]="true"
              buttonSize="small"
              iconLeft="translation"
              text="{{ t('account-dropdown-wrapper.set-language') }}"
              fill="text"
              (onClick)="onChangeLanguage()"
            >
            </xi-default-button>
          </div>
          <div class="dropdown-open__homepage-button">
            <xi-default-button
              [stretch]="true"
              buttonSize="small"
              text="{{ t('account-dropdown-wrapper.clear-testing-cache') }}"
              fill="text"
              (onClick)="clearEvalCache()"
            >
            </xi-default-button>
          </div>

          <div class="border-divider"></div>

          <div class="dropdown-open__sign-out-button">
            <xi-default-button
              [stretch]="true"
              fill="text"
              text="{{ t('account-dropdown-wrapper.sign-out') }}"
              (onClick)="logout()"
            >
            </xi-default-button>
          </div>

          @if (!this.authService.isSharedSession) {
            <div class="dropdown-open__account-info">
              <div class="dropdown-open__account-info-item">
                <p>{{ t('account-dropdown-wrapper.username') }}: {{ userLogin() }}</p>
                <div>
                  <xi-icon-button
                    icon="copy"
                    buttonSize="small"
                    [tooltip]="{ text: t('account-dropdown-wrapper.copy-to-clipboard') }"
                    (onClick)="onCopyToClipboard($event, userLogin())"
                  ></xi-icon-button>
                </div>
              </div>
              <div class="dropdown-open__account-info-item">
                <p>{{ t('account-dropdown-wrapper.account-identifier') }}: {{ account()?.id }}</p>
                <div>
                  <xi-icon-button
                    icon="copy"
                    buttonSize="small"
                    [tooltip]="{ text: t('account-dropdown-wrapper.copy-to-clipboard') }"
                    (onClick)="onCopyToClipboard($event, account()?.id)"
                  ></xi-icon-button>
                </div>
              </div>
              <div class="dropdown-open__account-info-item">
                <p>
                  {{ t('account-dropdown-wrapper.account-owner') }}:
                  {{
                    account()?.email_address
                      ? account().email_address
                      : account()?.name
                        ? account().name
                        : ''
                  }}
                </p>
                <div>
                  <xi-icon-button
                    icon="copy"
                    buttonSize="small"
                    [tooltip]="{ text: t('account-dropdown-wrapper.copy-to-clipboard') }"
                    (onClick)="onCopyToClipboard($event, account()?.email_address)"
                  ></xi-icon-button>
                </div>
              </div>
            </div>

            <div class="border-divider"></div>
            <div class="dropdown-open__account-info">
              <div class="dropdown-open__account-info-item">
                <p>{{ t('account-dropdown-wrapper.docs-used') }}:</p>
                <p>{{ accountCountsSafe().documentCount }}</p>
              </div>
              <div class="dropdown-open__account-info-item">
                <p>{{ t('account-dropdown-wrapper.docs-limit') }}:</p>
                <p>{{ accountCountsSafe().documentLimit }}</p>
              </div>
              <div class="dropdown-open__account-info-item">
                <p>{{ t('account-dropdown-wrapper.semantria-credits-left') }}:</p>
                <p>{{ accountCountsSafe().semantriaCredits }}</p>
              </div>
              <div class="dropdown-open__account-info-item">
                <p>{{ t('account-dropdown-wrapper.ai-studio-credits-left') }}:</p>
                <p>{{ spoteScenario }}</p>
              </div>
              <div class="dropdown-open__account-info-item">
                <p>{{ t('storage-used') }}:</p>
                <p>
                  {{ localStorageService.storageSizeInBytes() | bytes }} /
                  {{ localStorageService.LS_MAX_SIZE_IN_BYTES | bytes }}
                </p>
              </div>
              @if (driverAnalysisEnabled) {
                <div class="dropdown-open__account-info-item">
                  <p>{{ t('account-dropdown-wrapper.driver-analysis-credits-left') }}:</p>
                  <p>{{ driverAnalysisBalance }}</p>
                </div>
              }
              @if (translationEnabled) {
                <div class="dropdown-open__account-info-item">
                  <p>{{ t('account-dropdown-wrapper.translation-credits-left') }}:</p>
                  <p>{{ translationBalance }}</p>
                </div>
              }
              <div class="dropdown-open__account-info-item">
                <p>{{ t('account-dropdown-wrapper.spotlight-version') }}:</p>
                <p>{{ appVersion() }}</p>
              </div>
              <div class="dropdown-open__account-info-item">
                <p>{{ t('account-dropdown-wrapper.semantria-version') }}:</p>
                <p>{{ semantriaVersions?.semantria_version }}</p>
              </div>
              <div class="dropdown-open__account-info-item">
                <p>{{ t('account-dropdown-wrapper.salience-version') }}:</p>
                <p>{{ semantriaVersions?.salience_version.Version }}</p>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </app-account-dropdown>

  <!--Change Password Modal-->
  @if (showPasswordModal) {
    <app-lex-xi-modal
      [isVisible]="showPasswordModal"
      [canBackdropClose]="false"
      maxWidth="720px"
      (close)="onPasswordModalClosed()"
    >
      <ng-template appXIModalContent>
        @if (showPasswordModal) {
          <app-account-password (modalClosed)="onPasswordModalClosed()"></app-account-password>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
</ng-container>
